export function reverbDeviceInfoHeader() {
  return {
    'X-Reverb-Device-Info': JSON.stringify({
      platform: 'Web',
      app_version: null,
      platform_version: null,
    }),
  };
}
